import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export type Props = {
  size: number | [number, number];
  type?: 'horizontal' | 'vertical';
};

export default styled.div<Props>((props) => {
  const { size, type } = props;

  const standardSize = Array.isArray(size) ? size[0] : size;
  const mobileSize = Array.isArray(size) ? size[1] : size;

  if (type === 'vertical') {
    return {
      padding: `0px ${standardSize}px`,
      [mobileMediaQuery]: {
        padding: `0px ${mobileSize}`,
      },
    };
  }
  return {
    padding: `${standardSize}px 0px`,
    [mobileMediaQuery]: {
      padding: `${mobileSize}px 0px`,
    },
  };
});
